import { getData } from "@/data/store";
import { toast } from "@/ui/toast";

export const CARD_DRAG_TYPE = "application/x-hydra-card";

export function draggedCardId(dataTransfer: DataTransfer): string | null {
  const id = dataTransfer.getData(CARD_DRAG_TYPE);
  return id || null;
}

/** Bring a Card back to the active surface and place it in a board. */
export function moveCardToBoard(cardId: string, boardId: string | null, beforeId?: string | null): void {
  const workspace = getData().workspace;
  let card = workspace.getItem(cardId);
  if (!card || card.type !== "card") return;
  const changedSurface = !!card.trashedAt || !!card.archivedAt;
  const changedBoard = card.parentId !== boardId;
  if (card.trashedAt) workspace.restore(cardId);
  card = workspace.getItem(cardId);
  if (card?.archivedAt) workspace.unarchive(cardId);
  workspace.move(cardId, boardId, beforeId);
  // Reordering inside one board is already visible and can happen rapidly.
  // Confirm only an actual container/lifecycle move.
  if (changedSurface || changedBoard) {
    const board = boardId ? workspace.getItem(boardId) : null;
    toast.success(`Moved "${card?.title || "Untitled card"}" to ${board ? `"${board.title || "Untitled"}"` : "All cards"}`);
  }
}

export function archiveCard(cardId: string): void {
  const workspace = getData().workspace;
  let card = workspace.getItem(cardId);
  if (!card || card.type !== "card") return;
  if (card.trashedAt) workspace.restore(cardId);
  card = workspace.getItem(cardId);
  if (card?.archivedAt) return;
  workspace.archive(cardId);
  const title = card?.title || "Untitled card";
  toast.success(`Archived "${title}"`, {
    label: "Undo",
    onClick: () => {
      const current = workspace.getItem(cardId);
      if (current?.archivedAt && !current.trashedAt) workspace.unarchive(cardId);
    },
  });
}

export function restoreArchivedCard(cardId: string): void {
  const workspace = getData().workspace;
  const card = workspace.getItem(cardId);
  if (!card || card.type !== "card" || !card.archivedAt || card.trashedAt) return;
  workspace.unarchive(cardId);
  toast.success(`Restored "${card.title || "Untitled card"}" from Archive`);
}

export function trashCard(cardId: string): void {
  const workspace = getData().workspace;
  const card = workspace.getItem(cardId);
  if (!card || card.type !== "card" || card.trashedAt) return;
  workspace.trash(cardId);
  const title = card.title || "Untitled card";
  toast.success(`Moved "${title}" to Trash`, {
    label: "Undo",
    onClick: () => {
      if (workspace.getItem(cardId)?.trashedAt) workspace.restore(cardId);
    },
  });
}

export function restoreTrashedCard(cardId: string): void {
  const workspace = getData().workspace;
  const card = workspace.getItem(cardId);
  if (!card || card.type !== "card" || !card.trashedAt) return;
  workspace.restore(cardId);
  toast.success(`Restored "${card.title || "Untitled card"}" from Trash`);
}

export const archiveDraggedCard = archiveCard;
export const trashDraggedCard = trashCard;
